export type IconProps = {
	className?: string
	style?: React.CSSProperties
	children?: React.ReactNode
	height?: number
	width?: number
	// color?: string
}

export const getSizes = (_width?: number, _height?: number, defaultWidth: number = 25, defaultHeight: number = 25): [number, number] => {

	let width = _width;
	let height = _height;
	if (_width && !_height)
	{
		height = defaultHeight * (_width / defaultWidth);
	}
	else if (!_width && _height)
	{
		width = defaultWidth * (_height / defaultHeight);
	}

	return [width || defaultHeight, height || defaultHeight];
}